import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentFormComponent } from './payment-form/payment-form.component';
import { AlertModule, CardModule, InputModule, LinkModule, LocalLoaderModule, SosAccountStoreModule, SosAuthorizationStoreModule, SystemIconModule } from '@serviceos-ng/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PaymentsModule } from '../payments/payments.module';
import { PaymentDetailsCardComponent } from './payment-details-card/payment-details-card.component';



@NgModule({
  declarations: [
    PaymentFormComponent,
    PaymentDetailsCardComponent
  ],
  imports: [
    CommonModule,
    LinkModule,
    ReactiveFormsModule,
    LocalLoaderModule,
    InputModule,
    AlertModule,
    SystemIconModule,
    PaymentsModule,
    CardModule,
    SosAccountStoreModule,
    SosAuthorizationStoreModule,
  ],
  exports: [
    PaymentFormComponent,
    PaymentDetailsCardComponent
  ]
})
export class PaymentDetailsModule { }
